import * as React from 'react'
import { Elements, TextButton } from '@tfo/common'
import { observer, inject } from 'mobx-react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import './EmailSent.scss'

import { withRouter, RouteComponentProps } from 'react-router'
const { Heading4, Paragraph } = Elements

const onConfirmedEmailSent = () => {
    window.location.href = '/login'
}

class EmailSent extends React.Component<WrappedComponentProps & RouteComponentProps> {
    render() {
        const { intl } = this.props
        return (
            <div className="EmailSentWrapper">
                <div className="EmailSent">
                    <div className="EmailSentHeader">
                        <Heading4>{intl.formatMessage({ id: 'confirmation.email.heading' })} </Heading4>
                    </div>
                    <div className="EmailSentContent">
                        <Paragraph>
                            {intl.formatMessage({ id: 'confirmation.email.pragraph' })}
                        </Paragraph>
                        <TextButton className="ConfirmButton" onClick={onConfirmedEmailSent}>
                            {intl.formatMessage({ id: 'confirmation.email.button' })}
                        </TextButton>
                    </div>
                </div>
            </div>
        )
    }


} export default withRouter(inject('rootStore')(injectIntl(observer(EmailSent))))

